/**
 * The room's flag as the phone's entry points read it (P9): `chat_2_0_v1`, with the cached hint `routes/chat.tsx`
 * uses.
 *
 * `useServerFlag` reads OFF until the boot `/api/config` answers, so on a cold start a flag-on athlete would see the
 * floating "Ask a coach" button draw for a moment and then go, and the pill pop in after it. For a device whose last
 * good config said ON (`isServerFlagCachedOn`, a read-only hint over the persisted copy, never an answer) the flag
 * reads ON while the boot read has not settled; once it has, the live value is the only answer (a flag flipped off
 * since then simply goes back to the button). A device that has never heard the flag say ON, flag off included, never
 * waits: it reads exactly what `useServerFlag` reads.
 *
 * The id is written as a literal on the `useServerFlag` line, as the config-export rake test reads it. The settled
 * read is not reactive on its own, but `useServerFlag` re-renders its caller when the flags settle, so the next
 * render sees it.
 */
import { useServerFlag } from '../../hooks/useServerFlag';
import { areServerFlagsSettled, isServerFlagCachedOn } from '../../lib/supabase';
import { roomAvailableOnThisClient } from '../../lib/roomAvailability';

export function useRoomEntryFlag(): boolean {
  const live = useServerFlag('chat_2_0_v1');
  // Build 35: the native app never shows the room (`lib/roomAvailability`), so the flag reads OFF there.
  return roomAvailableOnThisClient() && (live || (!areServerFlagsSettled() && isServerFlagCachedOn('chat_2_0_v1')));
}
